import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbButtonModule, NbIconModule, NbSelectModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';

import { PagerComponent } from './pager.component';

/**
 * Wraps PagerComponent so feature modules can consume <bst-pager> without
 * forcing its declaration up into AppModule.
 */
@NgModule({
  declarations: [PagerComponent],
  imports: [CommonModule, NbButtonModule, NbIconModule, NbSelectModule, TranslateModule],
  exports: [PagerComponent],
})
export class PagerModule {}
